import './footer.scss';

import {
    Icon,
    LocalizedLink,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React, { useState } from 'react';

import LogoOCC from '../../images/Logo-OCC.svg';
import QuickRetailer from '../QuickRetailer';
import progiLogo from '@progymedia/sbi-web-occ/src/images/Progy.svg';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function Footer(props: { categoryTypes: any; catalogs: any }) {
    const { categoryTypes, catalogs } = props;
    const arrowIcon =
        'M0,11.024,4.768,6.246,0,1.468,1.468,0,7.714,6.246,1.468,12.492Z';
    const { t } = useTranslation('layout');
    const currentDevice = useMobileDetect();
    const [isOpened, setIsOpened] = useState(
        currentDevice.isDesktop()
            ? {
                  appliance: true,
                  venting: true,
                  parts: true,
                  service: true,
                  download: true,
              }
            : {
                  appliance: false,
                  venting: false,
                  parts: false,
                  service: false,
                  download: false,
              }
    );
    const { currentLocale } = usePageLocalization();
    const isUSA = currentLocale === 'en_US';

    return (
        <footer>
            <QuickRetailer />
            <div className='footer-wrap container-100'>
                <div className='footer-col'>
                    <div
                        className='title'
                        onClick={() => {
                            setIsOpened({
                                ...isOpened,
                                appliance: !isOpened.appliance,
                            });
                        }}
                    >
                        <span>{t('navigation.appliances.appliances')}</span>
                        <Icon
                            d={arrowIcon}
                            size='18'
                            viewbox='0 0 12.492 7.714'
                            transform={
                                isOpened.appliance
                                    ? 'translate(0 7.714) rotate(-90)'
                                    : 'translate(12.492) rotate(90)'
                            }
                            color='white'
                        />
                    </div>
                    {isOpened.appliance && (
                        <ul className='links'>
                            <li>
                                <LocalizedLink
                                    className='link'
                                    to='/wood-fireplaces/'
                                >
                                    {t('navigation.appliances.fireplaces')}
                                </LocalizedLink>
                            </li>
                            <li>
                                <LocalizedLink className='link' to='/stoves/'>
                                    {t('navigation.appliances.stoves')}
                                </LocalizedLink>
                            </li>
                            <li>
                                <LocalizedLink
                                    className='link'
                                    to='/wood-inserts/'
                                >
                                    {t('navigation.appliances.inserts')}
                                </LocalizedLink>
                            </li>
                        </ul>
                    )}
                </div>

                {!isUSA && (
                    <div className='footer-col'>
                        <div
                            className='title'
                            onClick={() => {
                                setIsOpened({
                                    ...isOpened,
                                    venting: !isOpened.venting,
                                });
                            }}
                        >
                            <span>
                                {t(
                                    'navigation.ventings-chimney.ventings-chimney'
                                )}
                            </span>
                            <Icon
                                d={arrowIcon}
                                size='18'
                                viewbox='0 0 12.492 7.714'
                                transform={
                                    isOpened.venting
                                        ? 'translate(0 7.714) rotate(-90)'
                                        : 'translate(12.492) rotate(90)'
                                }
                                color='white'
                            />
                        </div>
                        {isOpened.venting && (
                            <ul className='links'>
                                {categoryTypes.map(
                                    (categoryType: any, index: number) => {
                                        return (
                                            <li key={index}>
                                                <LocalizedLink
                                                    className='link'
                                                    to={`/venting/?filter=${categoryType.url}`}
                                                >
                                                    {categoryType.type}
                                                </LocalizedLink>
                                            </li>
                                        );
                                    }
                                )}
                            </ul>
                        )}
                    </div>
                )}

                <div className='footer-col'>
                    <div
                        className='title'
                        onClick={() => {
                            setIsOpened({
                                ...isOpened,
                                parts: !isOpened.parts,
                            });
                        }}
                    >
                        <span>
                            {t(
                                'navigation.parts-accessories.parts-accessories'
                            )}
                        </span>
                        <Icon
                            d={arrowIcon}
                            size='18'
                            viewbox='0 0 12.492 7.714'
                            transform={
                                isOpened.parts
                                    ? 'translate(0 7.714) rotate(-90)'
                                    : 'translate(12.492) rotate(90)'
                            }
                            color='white'
                        />
                    </div>
                    {isOpened.parts && (
                        <ul className='links'>
                            <li>
                                <LocalizedLink className='link' to='/archives/'>
                                    {t(
                                        'navigation.parts-accessories.replacement-part'
                                    )}
                                </LocalizedLink>
                            </li>
                            <li>
                                <LocalizedLink
                                    className='link'
                                    to='/accessories/'
                                >
                                    {t(
                                        'navigation.parts-accessories.accessories'
                                    )}
                                </LocalizedLink>
                            </li>
                        </ul>
                    )}
                </div>

                <div className='footer-col'>
                    <div
                        className='title'
                        onClick={() => {
                            setIsOpened({
                                ...isOpened,
                                service: !isOpened.service,
                            });
                        }}
                    >
                        <span>
                            {t('navigation.service-support.service-support')}
                        </span>
                        <Icon
                            d={arrowIcon}
                            size='18'
                            viewbox='0 0 12.492 7.714'
                            transform={
                                isOpened.service
                                    ? 'translate(0 7.714) rotate(-90)'
                                    : 'translate(12.492) rotate(90)'
                            }
                            color='white'
                        />
                    </div>
                    {isOpened.service && (
                        <ul className='links'>
                            <li>
                                <LocalizedLink className='link' to='/articles/'>
                                    {t('navigation.service-support.faq')}
                                </LocalizedLink>
                            </li>
                            <li>
                                <LocalizedLink className='link' to='/warranty/'>
                                    {t('navigation.service-support.warranty')}
                                </LocalizedLink>
                            </li>
                            <li>
                                <LocalizedLink className='link' to='/archives/'>
                                    {t('navigation.service-support.manuals')}
                                </LocalizedLink>
                            </li>
                            <li>
                                <LocalizedLink
                                    className='link'
                                    to='/comparator/'
                                >
                                    {t('navigation.service-support.comparator')}
                                </LocalizedLink>
                            </li>
                        </ul>
                    )}
                </div>

                <div className='footer-col'>
                    <div
                        className='title'
                        onClick={() => {
                            setIsOpened({
                                ...isOpened,
                                download: !isOpened.download,
                            });
                        }}
                    >
                        <span>{t('navigation.download.download')}</span>
                        <Icon
                            d={arrowIcon}
                            size='18'
                            viewbox='0 0 12.492 7.714'
                            transform={
                                isOpened.download
                                    ? 'translate(0 7.714) rotate(-90)'
                                    : 'translate(12.492) rotate(90)'
                            }
                            color='white'
                        />
                    </div>
                    {isOpened.download && (
                        <ul className='links brochure-links'>
                            <LocalizedLink to='/brochure-appareils/'>
                                {t('navigation.download.ventis-catalog')}
                            </LocalizedLink>
                            {currentLocale !== 'en_US' && (
                                <LocalizedLink to='/brochure-tuyaux/'>
                                    {t('navigation.download.venting-catalog')}
                                </LocalizedLink>
                            )}
                        </ul>
                    )}
                </div>

                <div className='footer-col last-col'>
                    <div className='title'>
                        <LocalizedLink to='/contact/'>
                            {t('navigation.service-support.contact')}
                        </LocalizedLink>
                    </div>
                    <div className='title'>
                        <LocalizedLink to='/videos/'>
                            {t('navigation.videos')}
                        </LocalizedLink>
                    </div>
                    <div className='title'>
                        <LocalizedLink to='/promotions/'>
                            {t('navigation.promotions')}
                        </LocalizedLink>
                    </div>
                    <div className='title'>
                        <LocalizedLink to='/warranty/'>
                            {t('navigation.warranty')}
                        </LocalizedLink>
                    </div>
                    <div className='title'>
                        <LocalizedLink to='/test-reports/'>
                            {t('navigation.testing-reports')}
                        </LocalizedLink>
                    </div>
                </div>

                <div className='logo-occ'>
                    <img src={LogoOCC} alt='Olympia Chimney of Canada Logo' />
                </div>
            </div>

            <div className='policies-line'></div>
            <div className='policies'>
                <div>
                    <LocalizedLink to='/shipping-policy/'>
                        {t('navigation.livraison-policy')}
                    </LocalizedLink>
                </div>
                <div>
                    <LocalizedLink to='/return-policy/'>
                        {t('navigation.return-policy')}
                    </LocalizedLink>
                </div>
                <div>
                    <LocalizedLink to='/privacy-policy/'>
                        {t('navigation.privacy-policy')}
                    </LocalizedLink>
                </div>
                <div>
                    <LocalizedLink to='/term-and-condition/'>
                        {t('navigation.terms-and-conditions')}
                    </LocalizedLink>
                </div>
            </div>
            <div className='developed-by'>
                <a target='__blank' href='https://www.progymedia.com'>
                    {t('navigation.developed-by')}{' '}
                    <img src={progiLogo} alt='Progymedia' />
                </a>
            </div>
            <div className='copyright'>
                &#169;
                {t('navigation.copyright', { year: new Date().getFullYear() })}
            </div>
        </footer>
    );
}
